import SectionHeading from "@/pages/home/components/SectionHeading";
import { aboutParagraphs, themePoints } from "@/mocks/homeContent";

export default function StorySection() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="剧情与主题"
          title="它讲的是一个怎样的故事"
          desc="不靠夸张的冲突，而是用日常职场里的细节，铺开一条关于善意、边界与成长的主线。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="space-y-5">
              {aboutParagraphs.map((para, i) => (
                <p
                  key={i}
                  className="text-sm leading-7 text-foreground-700 md:text-base md:leading-8"
                >
                  {para}
                </p>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="h-[220px] w-full md:h-[260px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20still%20life%20of%20a%20vintage%20typewriter%2C%20a%20cup%20of%20warm%20coffee%20and%20neatly%20stacked%20paper%20notebooks%20on%20a%20wooden%20desk%2C%20soft%20warm%20window%20light%2C%20cozy%20literary%20editorial%20mood%2C%20cream%20terracotta%20and%20amber%20color%20palette%2C%20painterly%20stylized%20rendering%2C%20high%20detail%2C%20no%20text&width=900&height=700&seq=secretary-about-01&orientation=squarish"
                  alt="以旧式打字机、咖啡与笔记本构成的暖色调办公静物插画"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <p className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  主题关键词
                </p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  善良 · 边界 · 职场群像 · 女性成长 · 现实质感
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {themePoints.map((point) => (
            <div
              key={point.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-700">
                <i className={point.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {point.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {point.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}